import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserRoutingModule } from './user-routing.module';
import { PersonalProfileComponent } from './components/personal-profile/personal-profile.component';
import { SharedModule } from '../shared/shared.module';
import { AdminUsersComponent } from './components/admin-users/admin-users.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms'; 
import { BankAccountsModule } from '../bank-accounts/bank-accounts.module';

@NgModule({
  declarations: [
    PersonalProfileComponent,
    AdminUsersComponent
  ],
  imports: [
    CommonModule,
    UserRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    BankAccountsModule
  ]
})
export class UserModule { }
